var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Resources = YouLi.Trip.Resources ? YouLi.Trip.Resources : {};

(function (YouLi) {
    (function (Trip) {
        (function (Resources) {

            YouLi.Trip.Resources.FilterItems = function (searchTerm) {

                $(".trip-resource-item").each(function () {
                    if ($(this).find(".display-name").text().toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0
                        || $(this).find(".linked-item-info a").text().toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0)
                        $(this).parent().removeClass("hidden");
                    else
                        $(this).parent().addClass("hidden");
                });

                // show/hide the "no results" label for each tab
                $(".trip-resources-list").each(function () {
                    $(this).find(".no-results-label").toggleClass("hidden", $(this).find(".trip-resource:not(.hidden)").length > 0);
                });
            };

            $(function () {

                $("#ResourcesSearchTerm").on("keyup", function () {
                    YouLi.Trip.Resources.FilterItems($(this).val());
                });

            });

        }(YouLi.Trip.Resources ? YouLi.Trip.Resources : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));